/**!
 *
 */
+function ($) {
    "use strict";

    var pickupWorkingDays = null,
        dropoffWorkingDays = null,
        showReservationModal = function (groupId, groupDesc, groupImage) {
            var $modal = $('#bookingModal');
            var groupId = groupId;
            var groupDesc = groupDesc;
            var groupImg = groupImage;
            $('[name="group_id"]', $modal).val(groupId);
            $('.m-subtitle', $modal).html(groupDesc);
            $('#bookingModalIcon', $modal).attr('src', groupImg);
            $modal.modal('show');
        },
        setStationSchedule = function (context, $container, date) {
            var $stationPickerEl = $container.find('[name=' + context + '_station]'),
                $calendarPickerEl = $container.find('[name=' + context + '_date]'),
                $timePickerEl = $container.find('[name=' + context + '_time]'),
                stationModel = $('option:selected', $stationPickerEl).data('model'),
                dayPrefix = null;

            if (stationModel !== undefined) {
                if (context == 'pickup') {
                    pickupWorkingDays = JSON.parse(stationModel['working_days']);
                    $calendarPickerEl[0]._flatpickr.set("disable", [function (date) {
                        return pickupWorkingDays.indexOf(date.getDay().toString()) == -1;
                    }]);
                } else {
                    if (context == 'dropoff') {
                        dropoffWorkingDays = JSON.parse(stationModel['working_days']);
                        $calendarPickerEl[0]._flatpickr.set("disable", [function (date) {
                            return dropoffWorkingDays.indexOf(date.getDay().toString()) == -1;
                        }]);
                    }
                }
            }
            if (date === null || date === undefined) {
                date = $calendarPickerEl[0]._flatpickr.parseDate($calendarPickerEl[0]._flatpickr.input.value, 'Y-m-d');
                if (date === null || date === undefined) {
                    return;
                }
            }

            if (date.getDay() >= 1 && date.getDay() <= 5) {
                dayPrefix = 'wk';
            } else {
                if (date.getDay() == 6) {
                    dayPrefix = 'st';
                } else {
                    if (date.getDay() == 0) {
                        dayPrefix = 'su';
                    }
                }
            }

            if (stationModel !== undefined) {
                if (dayPrefix) {
                    var openTime = stationModel[dayPrefix + '_open_time'];
                    var closeTime = stationModel[dayPrefix + '_close_time'];

                    if (stationModel['out_of_hours']) {
                        if (stationModel[dayPrefix + '_outofhours_start_time'] < openTime) {
                            openTime = stationModel[dayPrefix + '_outofhours_start_time'];
                        }
                        if (stationModel[dayPrefix + '_outofhours_end_time'] > closeTime) {
                            closeTime = stationModel[dayPrefix + '_outofhours_end_time'];
                        }
                    }

                    $timePickerEl.timepicker('option', {
                        'minTime': openTime, 'maxTime': closeTime
                    });
                }
            }
        };

    $(document).on('jedeye.reservationModal.show', function (ev, groupId, groupDesc, groupImage) {
        showReservationModal(groupId, groupDesc, groupImage);
    });

    $('a, button').on('jedeye.reservationModal.show', function (ev) {
        ev.stopImmediatePropagation();
        showReservationModal($(ev.target).data('group-id'), $(ev.target).data('group-desc'), $(ev.target).data('group-image'));
    });

    $('[data-control="reservation-form"]').each(function () {
        var $form = $(this);
        $form.on("submit", function (e) {
            e.preventDefault();
            var $el = $(this);
            $(this).request($el.data('component') + '::onReservationFormRequest', {
                data: $el.serialize(),
                loading: $.oc.stripeLoadIndicator,
                success: function (data) {
                    if (data.status !== undefined && data.status == 'error') {
                        // Disable auto trigger in order to allow to change more than one already
                        // filled input without submiting automatically on the first selection
                        $.oc.stripeLoadIndicator.hide(true);
                    }
                    this.success(data);
                },
                complete: function () {
                }
            });
        });


        if (typeof jQuery().timepicker != "undefined") {
            var showTimePicker = function ($field) {
                $field.prop('readonly', false);
                $field.timepicker('show');
                $field.prop('readonly', true);
            };

            $('.timepicker').timepicker({
                'scrollDefault': '09:00',
                'timeFormat': $('body').data("time-format"),
                'show2400': true,
                'disableTextInput': true,
                'appendTo': function (input) {
                    return $(input).parent();
                }
            });
        }

        if (typeof jQuery().flatpickr != "undefined") {
            var datePickers = [];

            $(".date-picker", $form).each(function () {
                // Date format sent to server
                var dateFormat = $(this).data('date-format') || "Y-m-d";
                // Date format presented to user
                var altFormat = $(this).data('alt-format') || "d/m/Y";
                // Date input mask presented to user
                // var altMask = $(this).data('alt-mask') || "99/99/9999";

                var $el = $(this),
                    locale = $('html').attr('lang');

                datePickers['#' + $el.attr('id')] = $el.flatpickr({
                    dateFormat: dateFormat,
                    altInputClass: "form-control",
                    altInput: true,
                    altFormat: altFormat,
                    disableMobile: true,
                    // allowInput: !(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)),
                    locale: locale,
                    maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
                    parseDate: function (dateStr) {
                        if (typeof window.DateFormatter != 'undefined') {
                            var fmt = new DateFormatter();
                            var date = fmt.parseDate(dateStr, dateFormat);
                            if (date == null)
                                return new Date();

                            return date;
                        }
                    },
                    onClose: function (dateObj, dateStr, instance) {
                        $el.trigger("jedeye.datepicker.close", [dateObj, dateStr, instance]);
                    },
                    onChange: function (dateObj, dateStr, instance) {
                        $el.trigger("jedeye.datepicker.change", [dateObj, dateStr, instance]);
                    },
                    onOpen: function (dateObj, dateStr, instance) {
                        $el.trigger("jedeye.datepicker.open", [dateObj, dateStr, instance]);
                    },
                    onReady: function (dateObj, dateStr, instance) {
                        setTimeout(function () {
                            $el.val(dateStr);
                        }, 200);
                    }
                });
            });

            var $pickupStation = $('#pickupStation', $form),
                $dropoffStation = $('#dropoffStation', $form);

            // DatePickers
            var $pickupDatePicker = $('#pickupDate', $form);
            $pickupDatePicker['_flatpickr'] = datePickers['#pickupDate'];
            $pickupDatePicker._flatpickr.set('minDate', new Date());

            var $dropoffDatePicker = $('#dropoffDate', $form);
            $dropoffDatePicker['_flatpickr'] = datePickers['#dropoffDate'];
            $dropoffDatePicker._flatpickr.set('minDate', new Date());

            var $pickupHourSelect = $('#pickupHour', $form),
                $pickupMinuteSelect = $('#pickupMinute', $form),
                $dropoffHourSelect = $('#dropoffHour', $form),
                $dropoffMinuteSelect = $('#dropoffMinute', $form),
                $pickupTimeSelect = $('#pickupTime', $form),
                $dropoffTimeSelect = $('#dropoffTime', $form),
                fullTimeFieldPresent = !!$pickupTimeSelect.length;

            $pickupHourSelect.on('select2-open', function () {
                if (this.selectedIndex > 0) {
                    var viewport = $('#select2-drop .select2-results');
                    var itemTop = viewport.find('.select2-highlighted').position().top;
                    viewport.scrollTop(itemTop + viewport.scrollTop());
                }
            });

            /** Pickup */
            $pickupStation.on('change', function (e) {
                setStationSchedule('pickup', $pickupStation.parents('form:first'), null);

                if ($dropoffStation.val() == "") {
                    $dropoffStation.val($(this).val()).trigger("change");
                    if ($form.data('auto-trigger') == '1') {
                        $pickupDatePicker._flatpickr.open();
                    }
                }
            });

            $pickupDatePicker.on('jedeye.datepicker.close', function () {
                setTimeout(function () {
                    $dropoffDatePicker._flatpickr.set('minDate', $pickupDatePicker._flatpickr.selectedDates[0]);
                    if ($dropoffDatePicker._flatpickr.selectedDates[0] < $pickupDatePicker._flatpickr.selectedDates[0]) {
                        $dropoffDatePicker._flatpickr.setDate($pickupDatePicker._flatpickr.selectedDates[0]);
                    }
                    if ($pickupDatePicker.val() != '') {
                        if (!fullTimeFieldPresent && $pickupHourSelect.val() == "" || $pickupMinuteSelect.val() == "") {
                            $pickupHourSelect.select2("open");
                        } else {
                            if (fullTimeFieldPresent && $pickupTimeSelect.val() == "") {
                                showTimePicker($pickupTimeSelect);
                            }
                        }
                    }
                }, 50);
            }).on('jedeye.datepicker.change', function (ev, dateObj, dateStr, instance) {
                setStationSchedule('pickup', $pickupDatePicker.parents('form:first'), dateObj[0]);
            });

            if (!fullTimeFieldPresent) {
                $pickupHourSelect.on('select2:close', function () {
                    $pickupMinuteSelect.select2("open");
                })
            } else {
                $pickupTimeSelect
                    .on('click', function () {
                        showTimePicker($(this));
                    })
                    .on('changeTime', function () {
                        if ($pickupTimeSelect.val() == "") {
                            $form.data('auto-trigger', '0');
                        } else {
                            $pickupTimeSelect.parents('.time-field:first').addClass('has-value');
                            if ($form.data('auto-trigger') == '1') {
                                setTimeout(function () {
                                    $dropoffDatePicker._flatpickr.open();
                                }, 500);
                            }
                        }
                    });

                $dropoffTimeSelect
                    .on('click', function () {
                        showTimePicker($(this));
                    });
            }

            /** Dropoff */
            $dropoffStation.on('change', function (e) {
                setStationSchedule('dropoff', $dropoffStation.parents('form:first'), null);

                if ($form.data('auto-trigger') == '1') {
                    if ($pickupStation.val() == "") {
                        $pickupStation.val($(this).val()).trigger("change");
                    }
                }
            });

            $dropoffDatePicker.on('jedeye.datepicker.close', function () {
                setTimeout(function () {
                    if ($dropoffDatePicker.val() != '') {
                        if (!fullTimeFieldPresent && $dropoffHourSelect.val() == "" || $dropoffMinuteSelect.val() == "") {
                            $dropoffHourSelect.select2("open");
                        } else {
                            if (fullTimeFieldPresent && $dropoffTimeSelect.val() == "") {
                                showTimePicker($dropoffTimeSelect);
                            }
                        }
                    }
                }, 50);
            }).on('jedeye.datepicker.change', function (ev, dateObj, dateStr, instance) {
                setStationSchedule('dropoff', $dropoffDatePicker.parents('form:first'), dateObj[0]);
            });

            if (!fullTimeFieldPresent) {
                $dropoffHourSelect.on('select2:close', function () {
                    $dropoffMinuteSelect.select2("open");
                })
            }
        }
    });
}(window.jQuery);